import { ParagraphBlock } from "./ParagraphBlock";

export * from "./ParagraphBlock";

export default ParagraphBlock;
